module.exports = __webpack_public_path__ + "static/img/0546_8.07a71cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/0546_8.jpg
// module id = v4ax
// module chunks = 1